import React from "react"
import { Drawer } from "vaul"

import PillButton from "@components/elements/V2/Buttons/PillButton"
import ListItem from "@components/elements/V2/ListItem"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"

export const TransferInstructions = () => {
  return (
    <>
      <div className="mb-24 mt-40 px-[25px] md:mb-[10px] md:mt-48">
        <Drawer.Title>
          <Typography
            text="Transfer ownership of your card machine"
            size="lead-sm"
            weight="medium"
            font="grotesk"
            color={Color.Charcoal}
          />
        </Drawer.Title>

        <Typography
          text="To transfer your device, you'll first remove it from your profile. Here's how:"
          size="body-sm"
          weight="book"
          font="grotesk"
          color={Color.Charcoal}
          className="mt-8"
        />
      </div>

      <div className="flex flex-col border-t border-light-gray px-[25px] pb-40 pt-[20px]">
        <div className="flex flex-col gap-20">
          <ListItem
            bodyText="Open card machine management"
            listNumber={1}
            textColor={Color.Charcoal}
          />
          <ListItem
            bodyText="Select your device"
            listNumber={2}
            textColor={Color.Charcoal}
          />

          <ListItem
            bodyText="Remove it from your profile"
            listNumber={3}
            textColor={Color.Charcoal}
          />

          <ListItem
            bodyText="Share the serial number with the new owner so they can register it"
            listNumber={4}
            textColor={Color.Charcoal}
          />
        </div>

        <PillButton
          size="medium"
          style="solid"
          text="Go to card machine management"
          color={Color.Blue}
          linkUrl="https://app.yoco.com/app/business-settings/card-machines"
          className="mt-32 !w-full"
        />
      </div>
    </>
  )
}
